import { Path } from "enums";
import RedeemPointsModule from "modules/vip-loyalty/redeem-points/redeem-points.module";
import RedemptionHistoryModule from "modules/vip-loyalty/redemption-history/redemption-history.module";
import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";

const VIPLoyaltyPage = () => {
  return (
    <Switch>
      <Route exact path={Path.VIPRedeemPoints} component={RedeemPointsModule} />
      <Route exact path={Path.VIPRedemptionHistory} component={RedemptionHistoryModule} />
      <Redirect to={Path.VIPRedeemPoints} />
    </Switch>
  );
};

export default VIPLoyaltyPage;
